exports.components = {
  "component---src-pages-cookie-policy-js": () => import("./../../../src/pages/cookie_policy.js" /* webpackChunkName: "component---src-pages-cookie-policy-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

